import { jsx } from "react/jsx-runtime";
import { useId } from "react";
import { ControlBody } from "../common/ControlBody.js";
import { Select } from "./Select/Select.js";
import { MultiSelect } from "./Select/MultiSelect/MultiSelect.js";
import "@mui/material";
import "../Button/Button.js";
import "../InputControl/InputControl.js";
import "../InputControl/Input/InputBase.js";
import "../PhoneInputControl/PhoneInputControl.js";
import "../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../IconButton/IconButton.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
import { inheritDataTestId } from "../../utils/dataTestId.js";
import "../TextareaControl/TextareaControl.js";
import "../SearchControl/SearchControl.js";
import "../../icons/24/System/Search.js";
import "../FormattedPhone/FormattedPhoneNumber.js";
import "../Avatar/styles.js";
import "../CheckboxGroup/Checkbox/styles.js";
import "../CheckboxGroup/styles.js";
import "../IconButtonNew/IconButton.js";
import "../RadioGroup/Radio/styles.js";
import "../RadioGroup/styles.js";
import "../RatingButton/styles.js";
import "../FloatingActionButton/styles.js";
import "../SortingButton/styles.js";
import "../SquareButton/styles.js";
import "../Toggle/styles.js";
import "../Dialog/Dialog.js";
import "../Dialog/StyledDialog.js";
import "../Chips/Chip/styles.js";
import "../ResultMarksNumber/styles.js";
import "../Progress/ProgressCircle/styles.js";
import "../Loaders/LoaderCircle/styles.js";
import "../Loaders/LoaderLine/styles.js";
import "../SegmentedControl/styles.js";
import "../ResultMarksText/styles.js";
import "../Link/styles.js";
import "../Tag/Tag.js";
import "../DatePicker/constants.js";
import "../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../external/classnames/index.js";
import "../Scrollbar/Scrollbar.js";
import "../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../MobileBottomSheet/MobileBottomSheet.js";
import "../List/ListItem/ListItem.js";
import "../Nowrap.js";
import "../List/ListItemTree/TreeListItem.js";
import "../List/ListItemTree/components/Label.js";
import "./Select/context/SelectContext.js";
import "../../icons/24/System/Check.js";
import "../../icons/24/Arrow/ChevronDown.js";
const SelectControl = ({
  placeholder,
  sx,
  inputRef,
  onChange,
  value,
  label,
  error,
  tip,
  optional,
  name,
  className,
  disabled,
  hideTipText,
  onBlur,
  compact = !0,
  size = "md",
  children,
  ignoreLabelHeight,
  ignoreHintHeight,
  multiple = !1,
  mobileHeader,
  renderValue,
  errorViewType,
  ...restProps
}) => {
  const id = useId();
  return /* @__PURE__ */ jsx(
    ControlBody,
    {
      sx,
      label,
      error,
      errorViewType,
      tip,
      optional,
      className,
      disabled,
      hideTipText,
      compact,
      size,
      ignoreLabelHeight,
      ignoreHintHeight,
      "data-test-id": inheritDataTestId(restProps, "container"),
      children: multiple ? /* @__PURE__ */ jsx(
        MultiSelect,
        {
          "data-test-id": DATA_TEST_ID_INHERITED,
          size,
          className,
          onChange,
          onBlur,
          disabled,
          name,
          id,
          value,
          error: !!error,
          placeholder,
          inputRef,
          mobileHeader: mobileHeader ?? label,
          renderValue,
          ...restProps,
          children
        }
      ) : /* @__PURE__ */ jsx(
        Select,
        {
          "data-test-id": DATA_TEST_ID_INHERITED,
          size,
          className,
          onChange,
          onBlur,
          disabled,
          name,
          id,
          value,
          error: !!error,
          placeholder,
          inputRef,
          mobileHeader: mobileHeader ?? label,
          renderValue,
          ...restProps,
          children
        }
      )
    }
  );
};
export {
  SelectControl
};
//# sourceMappingURL=SelectControl.js.map
